module.exports = __webpack_public_path__ + "static/img/engagement-kudzu.02a0a34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/engagement-kudzu.png
// module id = 44
// module chunks = 0